import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { UserRule } from '@verify/models';
import { filter, map, take } from 'rxjs';
import { AuthService } from '../auth.service';

export const hasRuleGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const authService: AuthService = inject(AuthService);
  const router: Router = inject(Router);
  const rules = route.data['rules'];

  let rulesRequired: UserRule[];
  if (!Array.isArray(rules)) {
    rulesRequired = [rules];
  } else {
    rulesRequired = rules;
  }
  return authService.currentUser$.pipe(
    filter((user) => !!user),
    take(1),
    map((user) => {
      for (const rule of rulesRequired) {
        if (!user?.rules?.includes(rule)) {
          return router.parseUrl('error?code=403');
        }
      }
      return true;
    }),
  );
};
